export const FETCH_TICKETS_ON_TICKET_UPDATE_THROTTLE_TIME = 500;
